<template>
    <b-container>
        <b-row>
            <b-col cols="auto">
                <multiselect
                    v-model="defaultValue"
                    :options="actions"
                    track-by="name"
                    label="name"
                    :multiple="false"
                    :allowEmpty="!!allowEmpty"
                    :reset-after="true"
                    placeholder="Acciones en lote"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""
                    @select="dispatchAction">
                </multiselect>
            </b-col>
        </b-row>
        
        <b-modal
            ref="chargeDateModal"
            hide-footer
            size="sm"
            title="Cobrar Recibo">
            <b-container class="py-2">
                <b-row>
                    <b-col>
                        <b-form-group
                            label="<strong>Fecha de cargo</strong>">
                            <v-date-picker
                                id="chargeDate"
                                v-model="chargeDate"
                                class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col col class="d-flex flex-row-reverse">
                        <div>
                            <button
                                class="btn btn-secondary btn-md"
                                @click="closeChargeDateModal(true)">
                                Aceptar
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

    </b-container>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import { setupCalendar, DatePicker } from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: "ConsignmentOverviewActionsSelector",
        components: {
            Multiselect,
            'v-date-picker': DatePicker,
        },
        props: {
            extraOptions: Boolean,
            allowEmpty: Boolean,
            allowEmpty: Boolean,
            receipts: Array,
            selectedReceipts: Array,
            receiptDeletePermission: Boolean,
            blockDeleteReceipt: Boolean | String,
        },
        data: function () {
            return {
                defaultValue: null,
                actions: [
                    { name: 'Seleccionar todos', $isDisabled: ( this.receipts.length == 0 ) },
                    { name: 'Deseleccionar todos', $isDisabled: true },
                    { name: 'Eliminar', $isDisabled: true },
                ],
                chargeDate: null,
                status: {
                    CREATED: ['Seleccionar todos','Deseleccionar todos', 'Eliminar'], 
                    PENDING: ['Seleccionar todos','Deseleccionar todos', 'Cobrar sin llamar','Anular / Condonar' ],
                    CHARGED: ['Seleccionar todos','Deseleccionar todos'],
                    RETURNED: ['Seleccionar todos','Deseleccionar todos', 'Cobrar sin llamar','Anular / Condonar' ],
                    CANCELED: ['Seleccionar todos','Deseleccionar todos'],
                    CHARGE_BY_BANK: ['Seleccionar todos','Deseleccionar todos'],
                    DEFAULT: ['Seleccionar todos','Deseleccionar todos']
                    },
                globalStatus: false
            }
        },
        methods: {
            dispatchAction (action) {
                if(action.name === 'Cobrar sin llamar') {
                    this.showChargeDateModal();
                } else {
                    this.$emit('selected-action', { action: action.name });
                }
            },
            showChargeDateModal() {
                this.$refs.chargeDateModal.show();
            },
            closeChargeDateModal(emit = null) {
                if (emit) {
                    this.$refs.chargeDateModal.hide();
                    this.$emit('selected-action', { action: 'Cobrar sin llamar', value: this.chargeDate });
                } else {
                    this.$refs.chargeDateModal.hide();
                }
            },
            checkStatusReceipts() {
                let status = []
                this.globalStatus = false
                if (this.selectedReceipts.length > 0) {
                    for (let selectedReceipt of this.selectedReceipts) {
                        for(let receipt of this.receipts) {
                            if (receipt.uuid === selectedReceipt) {
                               status.push(receipt.status)
                            }
                        }
                    }
                    const equalStatus = status.every(v => v === status[0])
                    if (equalStatus) {
                        this.globalStatus = status[0];
                    } else {
                        this.globalStatus = false;

                    }
                }
            }
                
        },
        watch: {
            receipts: function() {
                this.actions[0].$isDisabled = ( this.receipts.length == 0 );
            },
            selectedReceipts: function() {
                this.checkStatusReceipts()
                this.actions.map((action, index) => {
                    if (this.globalStatus) {
                        action.$isDisabled = (this.selectedReceipts.length > 0) && !(this.status[this.globalStatus].indexOf(action.name) > -1);
                        const actionDelete = this.actions.find(action => action.name === 'Eliminar');
                        actionDelete['$isDisabled'] = this.blockDeleteReceipt || !( this.selectedReceipts.length > 0 && this.receiptDeletePermission &&  this.status[this.globalStatus].indexOf(action.name) > -1);
                    } else {
                        for (let status of this.status['DEFAULT']) {
                            if (action.name === status) {
                                action.$isDisabled = false
                                this.actions[0].$isDisabled = ( this.receipts.length == 0 );

                         } else {
                                action.$isDisabled = true
                            }
                     }   
                    }

                }) 
            this.actions[0].$isDisabled = ( this.receipts.length == 0 );
            }
        },
        created() {
            this.chargeDate = null;
            if (this.extraOptions) {
                this.actions.splice(2,0, { name: 'Cobrar sin llamar', $isDisabled: true });
                this.actions.splice(3,0, { name: 'Anular / Condonar', $isDisabled: true });
            }
        },
    }
</script>

<style scoped>
    .btn-calendar {
        cursor: pointer !important;
    }
</style>
